/* eslint-disable import/prefer-default-export */
import * as actions from './duck/actions';
import reducer from './duck/reducer';

export { actions };

export default reducer;
